const Index = resolve => {
  require.ensure(["./index.vue"], () => {
    resolve(require("./index.vue"))
  }, "messages")
}

export default class MessagesRouter {

    static addRoutes(appRoutes) {

      appRoutes.push({ path: "messages", component: Index })
    }
}
